<template>
    <div>
        <Header class="header"></Header>
        <div class="router-view">
            <router-view :key="key"></router-view>
        </div>
    </div>
</template>
<script>
import Header from './header.vue'
export default {
    name: 'mainView',
    components: {
        Header
    },
    computed: {
        key() {
            return this.$route.path;
        }
    }
}

</script>


<style lang="scss" scoped>
.header{
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  background: #fff;
}
</style>